import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import assetsPath from '../../index.js';

/**
 * Nordnet chronos button atom. Used with chronos modal molecule.
 *
 * title - The text in the button.
 */
@customElement('nn-chronos-button')
export class ChronosButton extends LitElement {
  static styles = css`
    button {
      align-items: center;
      background-color: var(--nn-chronos-button_button_background, #fff);
      border: 3px solid var(--nn-chronos-button_button_border-color, #dbdbdb);
      border-radius: var(--nn-chronos-button_button_border-radius, 32px);
      box-shadow: var(
        --nn-chronos-button_button_box-shadow,
        16px 16px 24px #bebebe
      );
      cursor: pointer;
      display: flex;
      flex-direction: row;
      font-size: var(--nn-chronos-button_button_font-size, 16px);
      gap: var(--nn-chronos-button_button_gap, 16px);
      justify-content: center;
      padding: var(--nn-chronos-button_button_padding, 8px 32px);
    }
    button span {
      font-family: 'font-medium';
      font-size: var(--nn-chronos-button_button_span_font-size, 1.1em);
      text-align: center;
    }
  `;

  @property({ type: String }) title = 'Je veux être rappelé';

  render() {
    return html`
      <button>
        <img
          class="chronos__button--img"
          src="${assetsPath}/icons/user-headset-black-32.svg"
          alt="Headset phone"
        />
        <span class="chronos__text">${this.title}</span>
      </button>
    `;
  }
}
